module.exports = __webpack_public_path__ + "img/金属材料学3_10.b5f652a5.png";